/* eslint react/jsx-key: off */
import { EmailField, Identifier, Show, SimpleShowLayout, TextField, UrlField, useTranslate } from 'react-admin';
import CloudFrontImageField from 'src/components/CloudFrontImageField';

const GuestViewEmbedded = ({ id }: { id?: Identifier }) => {
  const translate = useTranslate();
  return (
    <Show title=" " id={id}>
      <SimpleShowLayout>
        <TextField source="name_jp" />
        <TextField source="name_en" />
        <TextField source="title" />
        <TextField source="company_short_name" />
        <TextField source="company_name" />
        <TextField source="company_address" />
        <TextField source="work_phone" />
        <TextField source="fax" />
        <TextField source="mobile" />
        <EmailField source="email" />
        <UrlField source="website" />
        <TextField source="others" />
        <CloudFrontImageField source="image" label={translate('resources.guest.fields.business_card')} />
      </SimpleShowLayout>
    </Show>
  );
};

export default GuestViewEmbedded;
